export default {
  GET_USED_COUNT_REQUEST: 'GET_USED_COUNT_REQUEST',
  GET_USED_COUNT_SUCCESS: 'GET_USED_COUNT_SUCCESS',
  GET_USED_COUNT_FAIL: 'GET_USED_COUNT_FAIL',

  GET_SUBMISSION_TYPE_COUNT_REQUEST: 'GET_SUBMISSION_TYPE_COUNT_REQUEST',
  GET_SUBMISSION_TYPE_COUNT_SUCCESS: 'GET_SUBMISSION_TYPE_COUNT_SUCCESS',
  GET_SUBMISSION_TYPE_COUNT_FAIL: 'GET_SUBMISSION_TYPE_COUNT_FAIL',
};
